module.exports = __webpack_public_path__ + "static/avatar-db5637a67d457e3f547789486a6968db.jpg";